import Vue from 'vue';
import { AxiosResponse } from 'axios';

interface UnitIdResponse {
  data: Array<{
    id: string;
  }>;
}

class UnitSearchService {
  private api: any;

  constructor() {
    this.api = Vue.prototype.$api;
  }

  /**
   * Search for a unit id by truck number
   * @param unitNumber The unit number to search for
   * @returns Promise<UnitIdResponse>
   */
  protected async getIdByNumber(unitNumber: string): Promise<UnitIdResponse> {
    try {
      const response: AxiosResponse<UnitIdResponse> = await this.api.get(
        `units/by-number/${unitNumber}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

const unitSearchService = new UnitSearchService();

Vue.prototype.$unitSearch = unitSearchService;

export default unitSearchService;
